module.exports = __webpack_public_path__ + "static/tony-hsieh-07ea4eebf7cbe071b5ef2fe99fed680c.jpg";